/**
 * @fileoverview Admin route protection component.
 * 
 * This component ensures that only authenticated admin users
 * can access protected admin routes.
 */

import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import adminAuthServiceGmail from '../../services/adminAuthServiceGmail';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Check if user is admin
        const isAdmin = adminAuthServiceGmail.isAdmin();
        setIsAuthenticated(isAdmin);
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/appadmin/login" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute; 